export default {
  // 公共
  cancel: 'Cancel',
  confirm: 'Confirm',
  tip: 'Tips',
  loading: 'Loading...', // 加载中...
  noData: 'No Data',
  noMoreData: 'No More Data', // 没有更多数据啦
  refreshText: 'Drag Down To Refresh', // 下拉刷新
  refreshActiveText: 'Release To Refresh', // 释放刷新
  refreshingText: 'Refreshing...', // 刷新中...
  copySuccess: 'Copied',
  copyFailed: 'Copy Failed',
  noSupportVideoFormat: 'Video Format Is Not Supported',
  tokenNoValid: 'Login Failed, Please Try Again',
  loginAgain: 'Please Login Again', // 请登录
  logoutSuccess: 'Logout Success',
  pleaseLogin: 'Please Login', // 请登录
  just: 'Just Now', // 刚刚
  minsAgo: 'Mins Ago', //  例如： 6分钟前
  hoursAgo: 'Hours Ago', // 例如： 6小时前
  daysAgo: ' Day Ago', // 一天前
  cYear: '', // 年
  cDay: '', // 日
  cMonth: {
    1: 'Jan',
    2: 'Feb',
    3: 'Mar',
    4: 'Apr',
    5: 'May',
    6: 'Jun',
    7: 'Jul',
    8: 'Aug',
    9: 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dec'
  },
  month: 'Month',
  hour: 'Hour',
  minute: 'Mins',
  tokenTips: 'You Need To Register First', // 您需要登录注册后才可进行操作哦！
  chooseStartDate: 'Choose Start Date',
  chooseEndDate: 'Choose End Date',
  dateCustomQuery: 'Custom Query',
  customStartDate: 'Start Date',
  customEndDate: 'End Date',
  dateTips: 'Start Time Must Before End Time',
  noVipTips: 'You\'re Not VIP',
  contactCustomer: 'Please contact Customer Service',
  networkAnomaly: 'Network anomaly',
  shareFailByNotAudit: 'Sharing failed, review has not passed', // 分享失败
  status: 'Status',

  // 语言
  langChinese: 'Traditional Chinese', // 中文（繁体）
  langVn: 'Vietnamese', // 越南语
  langEnglish: 'English', // 英语

  // 底部菜单
  footerHome: 'Home', // 首页
  footerHot: 'Popular', // 热门
  footerUploadVideo: 'Upload Video', // 上传短视频
  footerCs: 'Cs', // 客服
  footerMine: 'Me', // 我

  // 客服
  customerService: 'Customer Service', // 客服
  customerRespect: 'Hi，Dear', // Hi，尊敬的
  customerTourists: 'Visitor', // 游客
  customerWelcome: 'Welcome to CS Center', // 欢迎来到客服中心
  customerOnline: 'Online CS', // 在线客服
  customer24: '24/7 Customer Support', // 7x24小时专线服务贴心至上

  // 首页
  homeChangeNation: 'Change Regions', // 地区切换
  homeEnter: 'Enter', // 进入
  homeLongVideo: 'Films', // 影片
  homeShortVideo: 'Videos', // 短视频
  homeNoOpenNet: 'This Feature Coming Soon', // 该功能暂未开放！
  homeChooseLang: 'Choose Language', // 选择语言
  myQrcode: 'My QR Code', // 我的二维码
  downloadApp: 'Download App', // 下载app
  addFriend: 'Add Friend', // 添加朋友
  scanMe: 'Scan and follow me immediately', // 扫一扫，立即关注我
  saveQrcode: 'Save', // 保存
  chooseCurrency: 'Select currency', // 选择货币

  // 长电影
  homeLongRecommend: 'Recommended Today', // 今日推荐
  homeLongChange: 'Change', // 换一批

  // 短视频
  homeShort: 'Recommended Today', // 今日推荐

  // 发布视频
  homeNovel: 'novel',
  homeRecommend: 'Recommend',
  homeChoice: 'Category',
  homeRank: 'Ranking',
  homeFree: 'free',
  homeCompleted: 'Completed',
  homeNotCompleted: 'Serial',
  homeMore: 'more',
  homePublishIntro: 'Write A Description So More User Can See', // 在这里写点描述，让更多人看到～
  homePublishChooseCover: 'Choose Cover', // 选封面
  homePublishLabel: 'Hashtags', // 标签
  homePublishBtn: 'Post', // 发布
  homePublishPublic: 'Public·Everyone Can See', // 公开·所有人可见
  homePublishPrivate: 'Private·Only Me Can See', // 私密·仅自己可见
  homePublishing: 'Video Uploading，Please Wait', // 短视频上传中，请稍候
  homePublishFailed: 'Upload Failed, Please Upload Again', // 短视频上传失败，请重新上传
  homePublishUploadCover: 'Upload Cover', // 请上传封面图
  homePublishVideoSuccess: 'Works uploaded successfully', // 上传成功提示
  homePrivatePublished: 'Your work has been published and reviewed by staff! You can view this work in your personal homepage work',
  homePublishCancel: 'Reconsider',
  homePublishConfirm: 'OK',
  homePublishCancelTips: 'If you cancel publishing, the system will not keep your current edits',
  publishTitle: 'Publish Information',
  clickUploadVideo: 'Click to Upload Video',
  videoSizeMsg: 'Video size must not exceed 100MB',
  clickUploadCoverImg: 'Click to Upload Cover',
  coverImgMsg: 'The cover must match the video content',
  whoView: 'Who can view',
  writeTitle: 'Enter Title',
  writeTitleMsg: 'A good title can increase video click-through rate',
  writeTitlePlaceholder: 'Enter a title that matches the video content',
  writePrice: 'Set Price',
  writePricePlaceholder: 'Enter the price',
  memberPicker: 'Member Selection',
  videoPreview: 'Video Preview',
  videoPreviewMsg: 'Time limit for viewing by regular users after publication (5–15 seconds)',
  videoPreviewPlaceholder: 'Enter the watchable time (5–15 seconds)',
  videoLabel: 'Video Tags',
  videoLabelMsg: 'Choose the most relevant tags for the video, up to 4',
  allPeople: 'Everyone',
  memberUsers: 'Member Users',
  ordinaryUsers: 'Ordinary Users',
  uploadVideoMsg: 'Please upload a video',

  // hot
  hotLongVideo: 'Hot Films', // 热门影片
  hotShortVideo: 'Hot Videos', // 热门短视频

  // 影片
  hotLong: 'Hot Films', // 热门影片
  hotOverview: 'Overview',
  hotAllTime: 'All time',
  hotMonth: 'Hot this month',
  hotWeek: 'Hot this week',
  hotDay: 'Hot Today',
  hotFilmCount: '{0} films', // select currency
  hotFilmEmpty: 'There is no hot film~',

  // 热门短视频
  hotShort: 'Hottest', // 查看热榜
  hotShortHotList: 'Trending Search', // 热搜榜

  // 找回密码
  restPassword: 'Retreive Password', // 找回密码
  restPasswordVerifySent: 'Verification Code Sent', // 验证码已发送至
  restPasswordPsdRule: 'Password Needs 6-20 Digits, Numbers, Letters, Or Any Combination', // 密码需要6-20位，纯数字、纯字母，或者任意组合
  restPasswordEnterVerifyCode: 'Please Enter Verification Code', // 请输入验证码
  restPasswordEnterNewPsd: 'Please Enter New Password', // 请输入新密码
  restPasswordSelected: 'Please Tick Agree And Login', // 请先勾选，同意后再进行登录
  restPasswordAgree: 'Read And Agree', // 已阅读并同意
  restPasswordContract: 'User Agreement', // 用户协议
  restPasswordAnd: 'And', // 和
  restPasswordPrivate: 'Privacy Policy', // 隐私政策
  restPasswordFinished: 'Completed', // 完成
  restPasswordRestFailed: 'Reset Failed', // 重置密码失败

  // 登录
  login: 'Login', // 登录
  loginEmail: 'Login Via Email', // 邮箱号登录
  loginPhone: 'Login Via Mobile Number', // 手机号登录
  loginEnterPhoneNum: 'Please Enter Mobile Number', // 请输入手机号
  loginEnterEmail: 'Please Enter Email', // 请输入邮箱号
  loginEnterAccount: 'Please Enter Username', // 请输入用户名
  loginEnterEmailOrAccount: 'Please Enter Email / Username', // 请输入邮箱/用户名
  loginEnterPhoneOrAccount: 'Please Enter Phone / Username', // 请输入账号或手机号
  loginEnterPsd: 'Please Enter Password', // 请输入登录密码
  loginEnterRePsd: 'Enter Password Again', // 再次输入输入密码
  // restPasswordSelected: 'Please Tick Agree And Login', // 请先勾选，同意后再进行登录
  // restPasswordAgree: 'Read And Agree', // 已阅读并同意
  // restPasswordContract: 'User Agreement', // 用户协议
  // restPasswordAnd: 'And', // 和
  // restPasswordPrivate: 'Privacy Policy', // 隐私政策
  loginForget: 'Forgot?', // 忘记了？
  // restPassword: 'Retrieve Password', // 找回密码
  loginEmailPsd: 'Login Via Email / Username', // 邮箱密码登录
  loginPhonePsd: 'Login Via Phone Password', // 手机密码登录
  loginCountryArea: 'Choose Countries', // 选择国家和地区
  loginVn: 'Vietnam', // 越南
  loginPh: 'Philippines', // 菲律宾
  loginFailed: 'Login Failed', // 登录失败
  loginVerifyCodeSent: 'Verification Code Sent', // 验证码已发送
  loginVerifyCodeSentFailed: 'Failed To Send Verification Code', // 验证码发送失败
  loginTitle: 'Login To Discover More',

  // 注册
  register: 'Register',
  registerTitle: 'Login To Discover More', // 登录发现更多精彩
  // restPasswordSelected: 'Please Tick Agree And Login, // 请先勾选，同意后再进行登录
  // restPasswordAgree: 'Read And Agree', // 已阅读并同意
  // restPasswordContract: 'User Agreement', // 用户协议
  // restPasswordAnd: 'And', // 和
  // restPasswordPrivate: 'Privacy Policy', // 隐私政策
  registerAnd2: 'And', // 以及
  registerContract2: 'Operator Service Agreement', // 运营商服务协议
  registerCheckPhone: 'Operator Will Verify Your Mobile Number', // 运营商将对你提供的手机号进行验证
  registerCheckEmail: 'Operator Will Verify Your Email', // 运营商将对你提供的邮箱号进行验证
  // loginEnterPhoneNum: 'Please Enter Mobile Number', // 请输入手机号
  // loginEnterEmail: 'Please Enter Email', // 请输入邮箱号
  registerByPhone: 'Unregistered Mobile Number Will Auto Registered After Verification', // 未注册的手机号验证通过后将自动注册
  registerByEmail: 'Unregistered Email Will Auto Registered After Verification', // 未注册的邮箱号验证通过后将自动注册
  // loginEmail: 'Login Via Email', // 邮箱号登录
  // loginPhone: 'Login Via Mobile Number', // 手机号登录
  registerVerifyLogin: 'Verify And Login', // 验证并登录
  registerPadLogin: 'Login Via Password', // 密码登录
  // restPasswordEnterVerifyCode: 'Please Enter Verification Code', // 请输入验证码
  // restPasswordVerifySent: 'Verification Code Sent', // 验证码已发送至
  registerNext: 'Next', // 下一步
  // login: 'Login', // 登录
  registerSetLoginPsd: 'Please Set Login Password', // 请设置登录密码
  // restPasswordPsdRule: 'Password Needs 6-20 Digits, Numbers, Letters, Or Any Combination', // 密码需要6-20位，纯数字、纯字母，或者任意组合
  registerConfirm: 'Confirm', // 确认
  // loginEnterPsd: 'Please Enter Login Password', // 请输入登录密码
  registerContract3: 'Kind tips', // 温馨提示
  registerSafe: 'We Will Strictly Protect Your Personal Information', // 我们将严格保护你的个人信息安全
  registerAge: 'Are you over 18 years old', // 请问您是否满18岁
  registerAgreeAndLogin: 'Agree And Login', // 同意并登录
  registerDisAgree: 'Disagree', // 不同意
  // loginCountryArea: 'Choose Countries And Regions', // 选择国家和地区
  // loginVn: 'Vietnam', // 越南
  // loginPh: 'Philippines', // 菲律宾
  // loginVerifyCodeSent: 'Verification Code Sent', // 验证码已发送
  // loginVerifyCodeSentFailed: 'Failed To Send Verification Code', // 验证码发送失败

  // 影片大厅
  longVideoLobbySearch: 'Please Enter Keywords', // 请输入关键词查找片源
  longVideoLobbySearchBtn: 'Search', // 搜索
  longVideoLobbyBest: 'Best Recent', // 近期最佳
  longVideoLobbyNewUpdate: 'Latest Update', // 最近更新
  longVideoLobbyMoreView: 'Most Viewed', // 最多观看
  longVideoLobbyCollect: 'Top Favorites', // 最高收藏
  longVideoLobbyChooseVideo: 'Film selection', // 选片
  longVideoLobbyLabel: 'Label', // 标签
  longVideoLobbyMovieNum: '{num} video(s)', // xxx部影片
  longVideoLobbyDefault: 'Default Sort', // 预设排序
  longVideoLobbyHot: 'Popularity First', // 热度优先
  longVideoLobbyMoreCollect: 'Most Favorites', // 最多收藏

  // 搜索短视频
  // longVideoLobbySearch: 'Please Enter Keywords', // 请输入关键词查找片源
  // longVideoLobbySearchBtn: 'Search' // 搜索
  shortSearchNodata: 'No Search History', // 暂无搜索记录
  shortSearchAllHistory: 'Search History', // 全部搜索记录
  shortSearchClearAllHistory: 'Clear All Search History', // 清除全部搜索记录
  shortSearchHotList: 'Hottest Video', // 短视频热榜

  // 影片详情
  videoDetailVipTitle1: 'This Films Is Exclusive To VIP Members', // 本片是VIP会员专享内容
  videoDetailVipTitle2: 'Upgrade VIP Member To Watch', // 请开通VIP会员观看
  videoDetailVipTitle3: 'Upgrade VIP Member', // 开通VIP会员
  videoDetailBrief: 'Intro', // 简介
  videoDetailShare: 'Share', // 分享
  videoDetailContent: 'Plot', // 剧情
  videoDetailRecommend: 'Recommended For You', // 为您推荐
  videoDetailCountDown: '{countDownTime}S Skip Ad', // 5秒后关闭广告
  videoDetailCloseAd: 'Skip Ad', // 关闭广告

  // 个人中心
  // 关注和粉丝列表
  mineFollowing: 'Following', // 关注
  mineFollower: 'Followers', // 粉丝
  mineFollowed: 'Followed', // 已关注
  mineFollowMyself: 'Me', // 自己
  mineFollowEach: 'Friends', // 互相关注
  mineFollowBack: 'Follow Back', // 回关
  mineFollowCancel: 'Unfollow', // 取消关注
  mineFollowHim: 'His/Her', // 他的/她的
  mineFollowMe: 'Mine', // 我的
  mineFollowPerson: 'People', // 人
  memberCard: 'Membership Card',
  wallet: 'Wallet',
  shareInvitation: 'Share Invitation',
  promotionMoney: 'Earn from Promotion',
  fanGroup: 'Fan Group',
  drivingGroup: 'Join Group Driving',
  createCenter: 'Creator Center',
  community: 'Community Posts',
  myBuy: 'My Purchases',
  gold: 'Gold Coins',

  // vip中心
  vipCenter: 'VIP Center',
  // 观看历史
  historyTitle: 'Watch History', // 观看历史
  maxGift: 'Maximum gift of {money} coins',
  freeForeverWatch: 'Non-original VIP videos free to watch forever',
  dayFreeWatch: 'VIP videos free to watch {day} days per day',
  videoPayFreeWatch: 'Gold coin paid videos free to watch {num} per day',
  carGroup: 'Unlock nationwide escort car groups',
  welfareGroup: 'Unlock secret benefit groups',
  routeMovie: 'Exclusive HD movie route, ultra-fast playback',
  paymentMsg: 'Payment Reminder',
  payNow: 'Pay Now',

  // 设置
  settingSafeTitle: 'Account And Security', // 账号与安全
  settingSafeAvatar: 'Avatar', // 头像
  settingSafeUserName: 'Username', // 用户名
  settingSafeNickName: 'Nickname', // 昵称
  settingSafeInviteCode: 'Invitation Code', // 邀请码
  settingSafeEditPsd: 'Change Login Password', // 修改登录密码
  settingSafeUploadAvatar: 'Upload Photo', // 上传头像
  settingSafeUpload: 'Upload', // 上传
  settingSafeChoosePic: 'Choose Photo', // 请选择图片！
  settingSafeUploadFailed: 'Upload Failed', // 上传失败

  // 修改登录密码
  settingTitle: 'Settings', // 设置
  settingChangeLang: 'Language', // 语言切换
  settingUpdateLoginPsd: 'Change Login Password', // 修改登录密码
  settingGetVerifyCode: 'Get Verification Code', // 获取验证码
  settingUpdateLoginCheckNewPsd: 'Confirm New Password', // 确认新的登录密码
  settingUpdateLoginNewPsd: 'Enter New Password', // 请输入新的登录密码
  settingUpdateFailed: 'Failed To Change', // 修改失败
  settingUpdateByPhone: 'Change Password Via Mobile Number', // 通过手机号修改登录密码
  settingUpdateByEmail: 'Change Password Via Email', // 通过邮箱号修改登录密码

  // 任务中心
  taskTitle: 'Task Center', // 任务中心
  taskDaily: 'Daily Tasks', // 每日任务
  taskFinished: 'Finished', // 已完成
  taskGo: 'To Finish', // 去完成

  // 修改用户资料
  userInfoEditBg: 'Change Background', // 更换背景
  userInfoEditProcess: 'Data Completion', // 资料完成度
  userInfoEditAvatar: 'Change Avatar', // 点击更换头像
  userInfoEditMale: 'Male', // 男
  userInfoEditFemale: 'Female', // 女
  userInfoEditPrivate: 'Secret', // 保密
  userInfoEditNickName: 'Nickname', // 昵称
  userInfoEditUpdateNickName: 'Change Nickname', // 设置昵称
  userInfoEditSetNickName: 'Set Nickname', // 设置昵称
  userInfoEditBrief: 'Intro', // 简介
  userInfoEditIntroduce: 'Introduce Yourself', // 介绍一下自己
  userInfoEditFullInfo: 'Complete info+10%', // 完善信息加+10%
  userInfoEditGender: 'Gender', // 性别
  userInfoEditChoseGender: 'Choose Gender', // 选择性别
  userInfoEditBirthday: 'Birthday', // 生日
  userInfoEditChooseBirthday: 'Choose Birthday', // 选择生日
  userInfoEditAddress1: 'Location', // 所在地
  userInfoEditAddress2: 'Where Are You', // 你在哪儿
  userInfoEditPhone: 'Phone', // 手机号
  userInfoEditPhone1: 'Fill in your mobile number', // 填写你的手机号
  userInfoEditEmail: 'Email', // 邮箱
  userInfoEditEmail1: 'Fill in your email', // 填写你的邮箱号
  userInfoEditInviteCode: 'Invitation Code', // 邀请码
  userInfoEditUploadBg: 'Upload Photo', // 上传背景图
  userInfoEditToday: 'Today', // 今天
  userInfoEditSave: 'Save', // 保存
  userInfoEditMyNickName: 'My Nickname', // 我的昵称
  userInfoEditAddress3: 'Area', // 所在地区
  userInfoEditAddress4: 'Address', // 地址
  userInfoEditUpdate: 'Change', // 修改
  userInfoEditSet: 'Settings', // 设置
  userInfoVipTime: 'VIP Member Till', // VIP会员至

  // 用户中心
  userDetailIntro: 'Add A Bio, Let Everyone Know You', // 点击添加介绍，让大家认识你
  userDetailLogout: 'Logout', // 退出登录
  userDetailGetLike: 'Likes', // 获赞
  userDetailWork: 'Videos', // 作品
  userDetailPrivate: 'Privacy', // 私密
  userDetailLike: 'Liked', // 喜欢
  userDetailCollect: 'Favorite', // 收藏
  userDetailLogoutFailed: 'Logout Failed', // 退出失败
  userDetailDepositCenter: 'Recharge Center', // 充值中心
  userDetailEditInfo: 'Edit Information', // 编辑资料
  userDetailAddFriend: 'Add Friend', // 添加好友
  userDetailMessage: 'Message', // 私信

  // 评论组件
  commentCount: 'Comments', // xxx条评论
  commentPlaceholder: 'Say Something', // 来一起说点什么吧～
  commentSend: 'Send', // 发送
  commentContent: 'Add Comment', // 请输入评论内容

  // 我的钱包
  myWallet: 'Wallet', // 我的钱包
  myBalance: 'Total Balance', // 总资产
  myAToken: 'A Coins', // A币
  myIncome: 'My Income', // 我的收益
  myReceiptWay: 'Payment Method', // 收款方式
  myWithdraw: 'Withdraw', // 提现
  myBills: 'Bill', // 账单
  questionsTitle: 'Common Problem', // 常见问题
  whatIsATitle: '1、What Is A Coins', // 1、A币是什么？
  whatIsATips1: 'The Balance Is The Funds In {siteTitle} Payment. Tips Received And Income Earned From Live Chat Can Be Deposited Into Wallet Use As Consumption, Tips,Withdrawal And Other Functions', // 余额是在蚂蚁视频支付中的资金，聊天直播收到的红包、赚取的收入可以存入零钱、支持消费，红包，打赏，提现等功能
  whatIsATips2: 'A Coins And RMB Is 1:1 Conversion', // A币和人民币1:1换算
  whatIsATips3: 'A Coins And Tether Are Converted According To Huobi Global Real-time Exchange Rate', // A币和泰达币（火币网实时汇率）换算
  whatIsATips4: 'A Coins And Vietnamese Dong Are Converted According To The Company\'s Real-time Exchange Rate', // A币和越南盾根据公司实时汇率换算
  whatIsIncomeTitle: '2、What Is My Income？', // 2、我的收益是什么？
  whatIsIncomeTips1: 'My Income Is The A Coins You Get After You Complete The Check-in Task, Complete The Activity, And Reach The Promotion Target,Can beUse As Consumption, Tips,Withdrawal And Other Functions', // 我的收益实在你完成签到任务，完成活动，达到推广指标后获得的A币，支持消费，红包，打赏，提现等功能。
  payWaysTitle: '3、What Payment Methods Are Supported?', // 2、What Is My Income？
  payWaysTips1: 'If You\'re China User，We Will Provide The Payment Method Such As Bank/Wechat/Alipay/Tether', // 如果您是大陆用户，那么我们将会提供银行卡/微信/支付宝/泰达币等提现方式；
  payWaysTips2: 'If You\'re Vietnam User，We Will Provide The Payment Method Such As Gcash/Vietnam\'s Bank/Visa/Tether', // 如过您是越南用户，那么我们将会提供Gcash/越南银行/vsira/泰达币等提现方式；
  payWaysTips3: 'If You\'re Europe User，We Will Provide Tether Payment Method', // 如果您是欧美用户，那么我们将会提供泰达币提现方式；
  payWaysTips4: 'Click The Payment Method Enter The Page To Bind The Payment Method. When Withdrawing Choose The Payment Method To Withdraw', // 点击收款方式进入页面绑定对应的收款方式在提现时选择该方式提现即可。

  // 充值中心
  depositAToken: 'ANTG', // 充值A币
  depositVip: 'VIP', // 充值会员
  depositChannel: 'Payment Channel', // 收款通道
  depositOfflineInfo: 'Payment Info', // 收款信息
  depositCurrencyName: 'Currency Name', // 货币名称
  depositCurrencyLink: 'Currency Link', // 货币链路
  depositCurrencyAddress: 'Currency Address', // 货币地址
  depositPayerAddress: 'Remitter Address', // 汇款人地址
  depositPayerAddressHint: 'Please Enter Remitter Address', // 请输入汇款人地址
  depositAmount: 'Deposit Amount', // 存款金额
  depositChooseAmount: 'Choose Amount', // 请选择金额
  depositInputAmount: 'Please Enter Amount', // 请输入金额
  // depositTips: 'Note：Min. Recharge{min}{unit}；Max. Recharge{max}{unit}', // 注：最小充值xx元；最大充值xx元
  depositTipsMin: 'Note：Min. Recharge {min} {unit};', // Note：Min. Recharge xx ；Max. Recharge xx
  depositTipsMax: 'Max. Recharge{max}{unit}', // Note：Min. Recharge xx；Max. Recharge xx
  depositSubmit: 'Submit', // 确定提交
  depositNoChannel: 'No Payment Channel', // 暂无收款通道~
  depositPayFailed: 'Failed To Pay', // 支付失败
  depositDay: 'Day', // 天
  depositPleaseChoose: 'Choose', // 请选择

  // 收款方式
  withdrawalWays: 'Payment Method', // 收款方式
  withdrawalAlipayName: 'Alipay Name', // 支付宝姓名
  withdrawalAlipayAccount: 'Alipay Account', // 支付宝账号
  withdrawalShowAlipayAccount: 'Show Alipay Account', // 显示支付宝账号
  withdrawalCheckQrcode: 'Check QR Code', // 查看二维码
  withdrawalWechatName: 'WeChat Name', // 微信名称
  withdrawalUsername: 'Username', // 用户姓名
  withdrawalBankAccount: 'Bank Account', // 银行卡号
  withdrawalShowBankAccount: 'Show Bank Account', // 显示银行卡号
  withdrawalBankName: 'Bank Name', // 银行名称
  withdrawalWalletName: 'Wallet Name', // 钱包名称
  withdrawalWalletAddress: 'Wallet Address', // 钱包地址
  withdrawalTokenName: 'Crypto Name', // 币种名称
  withdrawalTokenLink: 'Crypto Link', // 链路名称
  withdrawalAddress: 'Payment Address', // 收款地址
  withdrawalAdd: 'Add Payment Method', // 添加收款方式
  withdrawalClose: 'Closed', // 关闭
  withdrawalAll: 'All', // 全部

  // 修改收款方式
  withdrawalWaysChoose: 'Choose Payment Method', // 请选择收款方式
  withdrawalWaysNo: 'No Payment Method', // 暂无收款方式
  withdrawalWaysInputInfo: 'Fill Information', // 填充信息
  withdrawalWaysWechatAccount: 'Wechat ID', // 微信号
  withdrawalWaysUploadQrcode: 'Upload Payment Code', // 上传收款码
  withdrawalWaysUploadMyQrcode: 'Upload My Payment Code', // 上传我的收款码
  withdrawalWaysPassword: 'Withdrawal Password', // 取款密码
  withdrawalWaysInputWechatName: 'Wechat Name', // 请输入微信名称
  withdrawalWaysInputAlipayName: 'Alipay Name', // 请输入支付宝姓名
  withdrawalWaysInputUserName: 'Username', // 请输入用户姓名
  withdrawalWaysInputWechatAccount: 'Wechat ID', // 请输入微信号
  withdrawalWaysInputAlipayAccount: 'Alipay Account', // 请输入支付宝账号
  withdrawalWaysInputBankAccount: 'Bank Card', // 请输入银行卡号
  withdrawalWaysInputBankName: 'Bank Name', // 请输入银行名称
  withdrawalWaysInputWalletAddress: 'Wallet Address', // 请输入钱包地址
  withdrawalWaysInputAddress: 'Withdrawal Address', // 请输入收款地址
  withdrawalWaysInputPassword: 'Withdrawal Password', // 请输入取款密码
  withdrawalWaysModify: 'Change', // 修改
  withdrawalWaysAdd: 'Add', // 添加
  withdrawalWaysTips: 'Reminder：If You Don\'t Have Withdrawal Password，The Withdrawal Password You Entered When Binding The Payment Method For The First Time Will Set As The Default Password', // 温馨提示：如您没有设置取款密码，首次绑定收款方式时，您输入的取款密码将作为默认取款密码使用
  withdrawalWaysModifyFailed: 'Failed To Change', // 修改失败
  withdrawalWaysAddFailed: 'Failed To Add', // 添加失败

  // 提现
  withdrawal: 'Withdrawal', // 提现
  withdrawalChooseWays: 'Choose Withdrawal Method', // 请选择提现方式
  withdrawalAccount: 'Withdrawal Account', // 提现账户
  withdrawalAmount: 'Withdrawal Amount', // 提现数量
  withdrawalInputAmount: 'Please Enter Withdrawal Amount（ANTG）', // 请输入提现数量（ANTG）
  withdrawalBalance: 'Withdrawal Balance', // 可提现余额
  withdrawalTipsTitle: 'Withdrawal Instructions', // 提现说明
  withdrawalTips1: 'Withdrawal Time：24 Hours', // 提现时间：24小时内随时提现
  withdrawalTips2: 'Each Withdrawal Limit：Min. 100 Coins', // 单笔提现限额：100个币起
  withdrawalNoways: 'You Haven\'t Bind The Withdrawal Info', // 您还未绑定该收款信息！
  withdrawalFailed: 'Failed To Withdraw', // 提现失败

  // 钱包设置
  walletSetting: 'Settings', // 设置
  walletModifyWithDrawPsd: 'Change Withdrawal Password', // 修改取款码
  bindMobile: 'Please bind your phone number first', // 您首先需要绑定手机号

  // 修改取款码
  walletModifyWithDrawPsdByPhone: 'Change Withdrawal Password Via Mobile Number', // 通过手机修改取款码
  walletModifyWithDrawPsdByEmail: 'Change Withdrawal Password Via Email', // 通过邮箱修改取款码
  walletModifyWithDrawPsdConfirm: 'Confirm New Withdrawal Password', // 确认新的取款密码
  walletModifyWithDrawPsdInput: 'Please Enter Withdrawal Password', // 请输入取款码

  // 账单
  billTitle: 'Bill',
  billSelectTypeTitle: 'Please Choose Transaction Types',
  billAll: 'All',
  billTo: 'To',
  // vip中心
  lookRules: 'Rules',
  vipRules: 'VIP Rules',
  vipOrdinary: 'Normal Member',
  vipTimeTo: 'VIP Member Till',
  vipJoinNow: 'Join VIP Now!',
  doDeposit: 'To Recharge',
  vipPrivilege: 'VIP Privilege',
  vipDetail: 'VIP Details',
  upMoney: 'Promotion Bonus',
  viewingTimes: 'Viewing Times',
  vipMovie: 'VIP Films',
  vipNovel: 'VIP Novel',
  vipCartoon: 'VIP Comics',
  unlimitedViewing: 'Unlimited Viewing',
  pleaseWaiting: 'Coming Soon',
  moviePlayTimes: 'Film Views',
  movieLikeTimes: 'Film Likes',
  movieCommentTimes: 'Film Comments',
  movieCollectTimes: 'Film Favorites',
  shortVideoPlayTimes: 'Video Views',
  shortVideoAwesomeTimes: 'Video Likes',
  shortVideoCommentTimes: 'Video Comments',
  shortVideoShareTimes: 'Video Shares',
  shortVideoLikeTimes: 'Video Likes',
  adClickTimes: 'Ad Clicks',
  // 签到中心
  signCenter: 'Check In Center',
  signRules: 'Rules',
  memberSign: 'Check In',
  continueSign: 'Checked-in Calendar',
  sign: 'Check In',
  signIn: 'Checked In',
  signInfo: 'Check-in Info',
  signTotalMoney: 'Checked-in Bonus',
  signContinueDay: 'Checked In Consecutive Days',
  signEndDate: 'Event End Time',
  signOrNot: 'Check In?',
  signSuccess: 'Checked In',

  //  下载页
  downloadTitle: 'Meet the next {siteTitle} station era', // 遇见下一个Titok站时代
  downloadBtn: 'Download APP', // 下载APP
  downloadAndroid: 'Download Android', // 下载Android
  downloadIos: 'Download Ios', // 下载Ios
  // 他人主页
  shareHomepage: 'Share', // 分享主页

  novelAddToShell: 'Add',
  novelAddedToShell: 'Added',
  novelPerson: '{0} person',
  novelReadCount: 'cumulative popularity',
  novelReadNow: 'read now',
  novelHot: 'Hot Novels',
  novelChapterNumber: 'Chapter {0}',
  novelLastChapter: 'Previous',
  novelIndex: 'Content',
  novelNextChapter: 'Next',
  novelChapterCount: 'Total {0} chapters',
  novelSortUp: 'Order',
  novelSortDown: 'reverse order',
  novelMyShell: 'My Bookshelf',
  novelClass: 'classification',
  novelNum: '{0}department',
  novelHistory: 'Reading History',
  novelSearchHistory: 'Search History',
  novelAlreadyInShell: 'Added to bookshelf',
  novelNoVipTips: 'You are not a VIP yet, please recharge now',
  novelSearchDiscover: 'Search Discovery',
  novelSort: 'Sort',
  novelRank: 'Rank',
  novelSerial: 'Serial',
  novelFree: 'Free',
  novelDone: 'Ended',
  novelCollect: 'Has been added to the bookshelf',
  novelUnCollect: 'Has been removed from the bookshelf',
  novelChoice: 'Bestseller Picks',

  // 维护
  maintenanceTitle: 'System Maintenance', // 系统维护
  maintenanceTime: 'Maintenance Time', // 维护时间

  // im
  message: 'message',
  privateMessage: 'DM',
  followBack: 'Back off',
  setAlias: 'Set Remarks',
  newFriend: 'New Friend',
  searchUser: 'Search User',
  friend: 'friend',
  silent: 'Do Not Disturb',
  stickToTop: 'sticky chat',
  addToBlacklist: 'pull black',
  sendMessage: 'Send message',
  allEmoji: 'All expressions',
  deleteFriend: 'Delete friend',
  unfollow: 'Unfollow',
  enterAlias: 'Enter remarks',
  follow: 'follow',
  addUser: 'Add User',
  remove: 'Remove',
  search: 'Search',
  followedYou: 'followed you',
  cancelSilent: 'Cancel cancels do not disturb',
  setTop: 'Top',
  cancelSetTop: 'cancel set top',
  justNow: 'just now',
  minuteAgo: '{0} minutes ago',
  hourAgo: '{0} hours ago',
  dayAgo: '{0} days ago',
  youAreNotFriend: 'You are not the friend of the other party, you can continue to send messages after the other party replies to you',
  yourBlockHim: 'You have blocked the other party, please continue to send messages after unblocking',
  yourAreBlock: 'Because of the other party\'s privacy settings, him cannot receive your message',
  audioTooShort: 'The recording time is too short',
  notSupportRecord: 'The device does not support recording',
  holdToTalk: 'Hold to talk',
  releaseSend: 'Let go to send, slide up to cancel',
  releaseCancel: 'Let go to cancel',
  whoFollowedYou: '{0} just followed you',
  whoSendYouMessage: 'Received {0} new messages',
  shareFailed: 'Share failed',
  shareSucceed: 'Share Success',
  shareMovie: 'Video Share',
  shareShortVideo: 'Short Video Share',
  shareNovel: 'Novel Share',
  shareToFriend: 'Share to friends',
  noFriends: 'No friends yet',
  conversationWarning: 'Because you are not following each other, you can only send one message before receiving a reply',
  toFollowSomeOne: 'No friends follow you yet, follow others~',

  restPasswordEnterNewRePsd: 'Please enter the new password again',
  phoneLogin: 'Mobile phone number login',
  accountLogin: 'Account password login',
  noAccount: 'No account yet',
  goRegister: 'Go to register',
  accountPasswordRegister: 'account password registration',
  resetWarning: 'The password cannot be reset without a mobile phone number or email address',
  phoneRegister: 'Mobile phone number registration',
  loginGetCode: 'Get Verification Code',
  phoneReset: 'Mobile phone number retrieved',
  lastMsgEffect: 'The verification code is valid within five minutes',
  reGetVerifyCode: 'Send the verification code again',
  emailReset: 'Email reset',
  restPasswordNotEquale: 'The two passwords are inconsistent',

  commentReply: 'Reply',
  commentClickLoadMore: 'Click to see more',
  commentExpandMore: 'Expand more replies',
  commentCollapse: 'Collapse',
  commentEnterTextOrImage: 'Please enter a comment or image',
  commentAllMsg: 'All messages',
  commentMentionMe: '@My',
  commentGetReply: 'Received comments',
  commentReplySuccess: 'Reply successful',
  commentMentionYou: 'Mentioned you',
  commentYou: 'Commented you',
  commentReplyYou: 'replied to you',
  commentInteraction: 'interaction message',
  commentHaveDeleted: 'comment has been deleted',
  commentConfirmDelete: 'Are you sure you want to delete this comment? ',
  commentNoMsg: 'No interactive message yet',

  // 社区
  // community: '社区',
  newest: 'Newest',
  marrow: 'Essence',
  communityVideo: 'Video',
  scan: 'Browse',
  like: 'Like',
  comment: 'Comment',
  postsDetail: 'Post Details',
  choseTopic: 'Choose Topic',
  publishMoney: 'Unlock Coins (up to 99 coins)',
  // publishTitle: 'Enter Title',
  publishTitlePlaceholder: 'Enter a title that matches the video content',
  publishContent: 'Enter Content',
  publishContentPlaceholder: 'Write some content here',
  publicImg: 'Upload Image',
  publicVideo: 'Upload Video',
  publicVideoTips: 'Maximum 100M',
  publicImgTips: 'Maximum 1M per image',
  buyPosts: 'Buy Post',
  buyPostsTips: 'Unlock to view all content',
  buyPostsTips1: 'Preview ended, requires {0} coins to purchase',
  buyMoneys: 'Insufficient account balance of {0} coins, please recharge coins',
  buyMoney: 'Insufficient account balance, please recharge coins',
  buyVip: 'Please purchase VIP',
  RechargeMoney: 'Coin Recharge',
  previewOver: 'Preview ended,',
  limitScanVideo: 'Preview {0} seconds, {1} coins to watch the full video',
  //  邀请分享
  inviteUserWatchTip: 'Invite one user to watch unlimited for 5 days',
  inviteUserRateTip: 'Invited users get 40 cashback on recharge',
  adultVideos: 'Adult Short Videos',
  codeScan: 'Scan QR Code',
  downAppWatch: 'Download APP to watch now',
  yourInviteCode: 'Your Invite Code',
  downQrCode: 'Download QR Code',
  copyLinkShare: 'Copy Link to Share',

  //  邀请记录
  inviteRecord: 'Invitation Record',
  invitedFriendLoginSuccess: 'The invited friend must log in for the invitation to be successful',

  //  推广代理
  promotion: 'Promotion Agent',
  activityContent: 'Activity Content',
  performanceTotal: 'Total Performance',
  detailsRevenue: 'Revenue Details',
  revenueTotal: 'Total Revenue',
  opportunitySeize: 'Seize the Opportunity',
  wealthFreedom: 'Achieve Financial Freedom Through Action',
  inviteSuccessfullyRechargeUser: 'Successfully invite 1 user to recharge, and you will receive a {0}% rebate',
  nowPromote: 'Promote Now',
  richClose: 'Wealth is Within Reach',
  promotionChannel: 'If you have a promotion channel and want to earn money, become an official agent',
  percentageProportion: 'Up to 80% commission, earning 100K per month is not a dream',
  serviceContact: 'Contact Customer Service',
  promoteHow: 'How to Promote',
  inviteSuccessfullyVipUser: 'Invite one person to get 3 days of VIP, can be stacked infinitely～',
  stepOne: 'Step One',
  stepTwo: 'Step Two',
  stepThree: 'Step Three',
  clickSave: 'Click【Save Image】or【Copy Link】',
  sendInfo: 'Send the image or link through various channels',
  exampleOne: 'Such as commonly used social apps',
  exampleTwo: 'Such as commonly used game apps',
  inviteDownloadAward: 'The invited person will automatically bind after downloading the app and immediately receive a rebate when recharging (withdrawable)',

  //  我加入的粉丝团
  fansGroup: 'Fans Group',
  fanClubNumber: 'Fan Club Members',
  joinedDay: 'Joined for {day} days',

  //  创作者中心
  searchVideo: 'Search videos/tags/users',
  workManage: 'Work Management',
  published: 'Published',
  reviewPending: 'Pending Review',
  fansExclusive: 'Fans Exclusive',
  greatGods: 'Great Gods',
  haveNumPeople: 'Already {num} people',
  becomeCreator: 'Become a 18Porn Creator',
  makeMoneyNow: 'Earn Money Now',
  createdYourselfFanGroup: 'Created your own fan club',
  createFanGroup: 'Create a Fan Club',
  creationStrategy: 'Creation Strategy',

  //  创建粉丝团
  fanClubName: 'Fan Club Name',
  fanClubNamePlaceholder: 'Enter up to 10 characters',
  fanClubNameMsg: 'Enter fan club name',
  fanClubIntroduction: 'Fan Club Intro',
  fanClubIntroductionMsg: 'Enter intro',
  fanClubMonth: 'Monthly Ticket',
  fanClubMonthMsg: 'Enter monthly ticket',
  fanClubSeason: 'Seasonal Ticket',
  fanClubSeasonMsg: 'Enter seasonal ticket',
  fanClubYear: 'Annual Ticket',
  fanClubYearMsg: 'Enter annual ticket',
  ticketPlaceholder: 'Set > 30 coins',

  //  排行榜
  ranking: 'Ranking',
  richRanking: 'Rich List',
  originalWorkRanking: 'Original Works',
  originalPopularityRanking: 'Original Popularity',
  originalLikeRanking: 'Original Likes'
};
